const templateUrl = require('./views/skip-shipment-button.html');

module.exports = {
  bindings: {
    shipment: '<ogFor'
  },
  controller: 'SkipShipmentController',
  templateUrl: templateUrl
};
